import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M5 1h14a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H5zm.5 1h13a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5zM6 4v12h12V4H6zm6 11a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm1.125-4.109c-.163.085-.37.15-.625.202V12.5a.5.5 0 1 1-1 0v-1.49a.9.9 0 0 1 .737-.885c.204-.038.349-.08.426-.12.507-.265.837-.81.837-1.422C13.5 7.704 12.824 7 12 7s-1.5.704-1.5 1.583a.5.5 0 1 1-1 0C9.5 7.161 10.615 6 12 6s2.5 1.161 2.5 2.583c0 .984-.537 1.871-1.375 2.308z"
});

var SvgPhotoMissing = function SvgPhotoMissing(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgPhotoMissing;